import { server } from '../engine/server'
import { user } from '../controllers/user'
import { modal } from '../utilities/modal'

import update from 'immutability-helper';

var SensorAnalytics = Class.create({

    api: 'https://dev.device-service.particlespace.com/v1/api/analytics/trends',
  	initialize: function() {
        if (process.env.ENVIRONMENT == 'prod') {
            this.api = 'https://device-service.particlespace.com/v1/api/analytics/trends';
        }
	},
	getTrends: function(start, end, building_id, callback) {
		const params = {
            belongs_to: user.userInfo.belongs_to,
            building_id: building_id,
            start: start,
            end: end
        }
		var data = server.getData(this.api, params, true, 'POST', true);
		// #  Listen to our data
		data
		.done(function(response){
			if(callback) {
				callback(response)
			}
		})
		.fail(function(e){
			console.log(e);
		});
	}
});

export let sensorAnalytics = new SensorAnalytics();


// WEBPACK FOOTER //
// app/core/controllers/SensorAnalytics.js